import { Api } from '../api';

export const createUserImportationEmail = async () => {
  return Api.post('/user/importationEmailAddress');
};
